var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24PxCustomisationDecoration01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-customisation-decoration-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,11a5,5,0,1,1,5-5A5,5,0,0,1,12,11Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,12,3Zm5,15.77L18.39,21H15.61L17,18.77M17,15l-5,8H22l-5-8Zm7-3H0v2H24ZM6.32,17.47l1.86,1.35L7.47,21H5.17l-.7-2.18,1.85-1.35m0-2.47-4.2,3.06L3.72,23h5.2l1.61-4.94L6.32,15Z",
    fill: "#242f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24PxCustomisationDecoration01);
export default __webpack_public_path__ + "static/media/24px-customisation-decoration-01.35267cc6c261e2f314215a76465e90b7.svg";
export { ForwardRef as ReactComponent };